/**
 * User Model Instance
 */

define(function(require) {
    'use strict';

    var _ = require('underscore');
    var server = require('server');
    var UserModel = require('modules/user/user.model');

    return UserModel.extend(/** @lends UserModel.prototype */ {

        /**
         * Update user info in IMS. Used in model sync
         * @private
         * @param  {Model}  model   user model
         * @param  {Object} options
         * @return {Deferred}
         */
        _update: function(model, options) {
            return server.send({
                ID: 33045,
                description: 'Update player info',
                responses: [33006, 31008],
                changeTimestamp: window.Playtech.API.formatter.getDateForIms(new Date()),
                dataMap: options.ageVerificationData || _.omit(this.get('userDetails'), 'streetName', 'buildingNumber'),
                addressDetails: _.pick(this.get('userDetails'), 'streetName', 'buildingNumber')
            }).done(options.success).fail(options.error);
        },

        requestPermanentExclusion: function() {
            return server.send({
                ID: 33045,
                description: 'Request permanent exclusion',
                responses: [33006, 31008],
                dataMap: {
                    custom20: 'PERMANENTEXCLUSION'
                }
            });
        }
    });
});
